<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ restaurant.title }}</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <RestaurantsTabLinks />

                    <IntegrationNotice
                        :has-integration="!!restaurant.alias"
                        :is-business-admin="!adminOnly"
                    />

                    <div class="flex mt-2">
                        <ProductFinder
                            business_type="restaurant"
                            :business_id="$route.params.id"
                            @select="selectDish"
                        />
                    </div>
                    <div
                        v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly) || (restaurant.alias && adminOnly)" 
                        class="flex flex-row-reverse">
                        <CButton
                            color="primary"
                            class="mt-2"
                            @click="create"
                        >Создать</CButton
                        >
                    </div>
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pb-3">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <th class="d-md-block d-none"><input v-model="areTableItemsDraggable" type="checkbox" /></th>
                                    <th>Приоритет</th>
                                    <th>Стоплист</th>
                                    <th>Название</th>
                                    <th class="desktop-only">Категории</th>
                                    <th>Цена</th>
                                    <th v-if="adminOnly">Скидка</th>
                                    <th></th>
                                </thead>
                                <component
                                    :is="!isMobile && areTableItemsDraggable ? 'draggable': 'tbody'"
                                    v-model="dishes"
                                    tag="tbody">
                                    <tr v-for="dish in dishes" :key="dish.id">
                                        <td class="d-md-block d-none">
                                            <CIcon
                                                :height="24"
                                                :content="$options.icons.cilCursorMove"
                                                class="cursor-pointer"
                                            />
                                        </td>
                                        <td>
                                            {{ dish.priority }}
                                        </td>
                                        <td>
                                            <CCol sm="9">
                                                <CSwitch
                                                    :checked.sync="dish.blocked"
                                                    color="dark"
                                                    shape="pill"
                                                    variant="opposite"
                                                    @update:checked="updateDish(dish)" />
                                            </CCol>
                                        </td>
                                        <td>
                                            <CLink :to="`/restaurants/${restaurant.id}/dishes/${dish.id}`">{{ dish.title }}</CLink>
                                        </td>
                                        <td class="desktop-only"> {{ cutCategories(dish.categories) }} </td>
                                        <td>
                                            <p>{{ dish.price }}</p>
                                            <p class="text-gray-400 text-xs">
                                                {{ dish.weight }} {{ UNITS_ENUM[dish.units] }}
                                            </p>
                                        </td>
                                        <td v-if="adminOnly">
                                            <CSelect
                                                horizontal
                                                class="mb-0"
                                                :options="promotionsOptions"
                                                :value.sync="dish.promotion_id"
                                                placeholder="Выберите скидку..."
                                                @change="setPromotion(dish, $event)"
                                            />
                                        </td>
                                        <td v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly)">
                                            <input
                                                v-model="dish.enabled"
                                                type="checkbox"
                                                @change="updateDish(dish)"
                                            />
                                        </td>
                                    </tr>
                                </component>
                            </table>
                        </div>
                    </CRow>
                </CCardBody>
                <CCardFooter v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly) || (restaurant.alias && adminOnly)">
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create"
                    >Создать</CButton
                    >
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove } from '@coreui/icons';
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';
    import IntegrationNotice from '@/components/IntegrationNotice';
    import ProductFinder from '@/components/ProductFinder';
    import { UNITS_ENUM } from '@/utils/units';

    export default {
        name: 'RestaurantDishes',

        components: {
            RestaurantsTabLinks,
            IntegrationNotice,
            draggable,
            ProductFinder,
        },

        data() {
            return {
                restaurant: {},
                dishes: [],
                promotions: [],
                areTableItemsDraggable: true,
                UNITS_ENUM
            };
        },
        computed: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
            promotionsOptions: function() {
                const promotionsOptions = [];
                this.promotions.forEach(promotion => {
                    if(promotion.enabled && promotion.delivery_type === null){
                        promotionsOptions.push({
                            value: promotion.id,
                            label: promotion.title
                        });
                    }
                });
                promotionsOptions.push({
                    value: 'null',
                    label: 'Без скидки',
                })
                return promotionsOptions;
            },
            isMobile() {
                return window.innerWidth < 768
            }
        },
        async mounted() {
            const id = this.$route.params.id;
            try {
                const promotions = await Vue.axios.get('/common-promotions');
                this.promotions = promotions.data;

                const rests = await Vue.axios.get('/restaurants/' + id);
                this.restaurant = rests.data;

                const dishes = await Vue.axios.get('/restaurants/' + id + '/dishes');
                this.dishes = dishes.data;

                // this.dishes = await Promise
                //     .all(dishes.data.map(async dish => ({ ...dish, hasPicture: await this.hasPicture(dish.picture) })));
            }
            catch (e) {
                this.$root.$emit('showError', 'Ошибка загрузки данных.');   
            }
        },

        icons: {
            cilCursorMove,
        },

        methods: {
            save() {
                // Save order only
                const reorder = [];
                let index = 0;
                this.dishes.forEach(dish => {
                    reorder.push({
                        id: dish.id,
                        position: ++index,
                    });
                });
                Vue.axios
                    .post('/restaurants/' + this.restaurant.id + '/dishes/reorder', {
                        reorder: reorder,
                    })
                    .then(() => {
                        this.$router.push('/restaurants/' + this.restaurant.id);
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },
            updateDish(dish) {
                if (dish.promotion_id) {
                    dish.promotion_id = +dish.promotion_id;
                }
                Vue.axios.post(`/restaurants/${ this.restaurant.id }/dishes/update/${ dish.id }/block`, {
                        id: dish.id,
                        promotion_id: dish.promotion_id,
                        blocked: dish.blocked,
                        enabled: dish.enabled
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },
            create() {
                this.$router.push(
                    '/restaurants/' + this.restaurant.id + '/dishes/create'
                );
            },

            getBadge(status) {
                return status ? 'success' : 'secondary';
            },

            // async hasPicture(picture) {
            // const result = await new Promise((resolve, reject) => {
            //     var img = new Image()
            //     img.onload = function(){
            //         resolve('Да')
            //     }
            //     img.onerror = function(){
            //         reject('Нет')
            //     }
            //     img.src = picture;
            // }).then(res => res).catch(err => err);
            // return result;
            // },

            selectDish(id) {
                this.$router.push('/restaurants/' + this.restaurant.id + '/dishes/' + id);
            },

            setPromotion(dish, event){
               dish.promotion_id = event.target.value;
               updateDish(dish);
            },

            cutCategories(categories) {
                const catString = categories.map(item => item.title).join(', ');
                return catString.length > 29 ? `${catString.slice(0, 30)}...` : catString;
            },
        },
    };
</script>
<style lang="scss" scoped>
.table {
    tr {
        td {
            padding: .2rem .75rem;
            vertical-align: middle;

            &:nth-child(2) {
                max-width: 30vw;
            }
        }
    }
}

@media (max-width: 767px) {
    .desktop-only {
        display: none;
    }
}
</style>
